import {
  Alert,
  AlertTitle,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  Paper,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ConfigAndMapDetailsTable from "./ConfigAndMapDetailsTable";

// import ConfigAndMapDetailsTable from "./ConfigAndMapDetailsTable";

interface Props {
  open: boolean;
  handleClose: () => void;
  familyTitle: string;
  familyType: string;
  familyName: string;
  familyCount: number;
}

const tableHeadings = {
  metric: "Metric",
  derivation: "Derivation",
};
const rows = [
  {
    metric: "ftd",
    derivation: "as delivered from unifier",
  },
  {
    metric: "qftd",
    derivation: "as delivered from unifier",
  },
  {
    metric: "cpa_income",
    derivation: "as delivered from unifier",
  },
  {
    metric: "revshare_income",
    derivation: "as delivered from unifier",
  },
  {
    metric: "net_revenue",
    derivation: "as delivered from unifier",
  },
  {
    metric: "total_income",
    derivation: "as delivered from unifier",
  },
];

const filteringColumns = [
  "%Commission",
  "CPACommission",
  "Netrevenue",
  "TotalBets/Hands",
  "brand_action_date",
  "cpacommissioncount",
  "downloads",
  "firstdepositcount",
  "purchaccount",
  "purchaccountcount",
  "totalcommission",
];

const details = [
  {
    label: "Interface",
    value: "IncomeAccess",
  },
  {
    label: "Destination Table",
    value: "daily_user_performance",
  },
];

const advisor_details = [
  {
    label: "Interface",
    value: "IncomeAccess",
  },
  {
    label: "Destination Table",
    value: "daily_brand_campaign_performance",
  },
];

const fetcher_details = [
  {
    label: "Interface",
    value: "IncomeAccess",
  },
  {
    label: "Report",
    value: "ACIDReport",
  },
  {
    label: "Collection method",
    value: "periodic",
  },
  {
    label: "Collection Type",
    value: "API",
  },
  {
    label: "Sub-filtering",
    value: "none",
  },
];

const ConfigAndMapDetailsModal = ({
  open,
  handleClose,
  familyTitle,
  familyType,
  familyName,
  familyCount,
}: Props) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 10px 0px" }}>
            {familyName} ({familyCount}){" "}
            <span style={{ color: "#00000061" }}>
              {" "}
              {familyTitle} {familyType} details
            </span>
          </DialogTitle>
          <Typography variant="body2" color="#00000061">
            Used By 87 brands ● <span>CSV Format</span>{" "}
          </Typography>

          <Typography mt={2}>\\ Fetcher configs details \\</Typography>
          {/* Fetcher config details */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "2fr 1.8fr 5fr",
              gap: 3,
              py: 2,
            }}
          >
            {fetcher_details.map((item) => (
              <Box key={item.label}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#00000099",
                    mb: 0.2,
                  }}
                >
                  {item.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "#000000DE",
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          <Typography mt={2}>\\ Unifier map details \\</Typography>
          {/* Unifier map details */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "2fr 1.8fr 5fr",
              gap: 3,
              py: 2,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {details.map((item) => (
              <Box key={item.label}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#00000099",
                    mb: 0.2,
                  }}
                >
                  {item.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "#000000DE",
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Filtering Definition */}
          <Box sx={{ mt: 2 }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#000000DE",
                mb: 1,
              }}
            >
              Filtering Definition
            </Typography>

            {/* Chips */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              {filteringColumns.map((column) => (
                <Chip
                  key={column}
                  label={column}
                  variant="outlined"
                  sx={{
                    height: "28px",
                    borderRadius: "16px",
                    borderColor: "#d9d9d9",
                    backgroundColor: "#fff",
                    fontSize: "14px",
                    color: "#000000DE",
                    px: 0.8,

                    "& .MuiChip-label": {
                      px: 0.2,
                    },
                  }}
                />
              ))}
            </Box>
          </Box>

          <Typography mt={2}>\\ Advisor map details \\</Typography>
          {/* Fetcher config details */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "2fr 1.8fr 5fr",
              gap: 3,
              py: 2,
              borderBottom: "1px solid #e0e0e0",
            }}
          >
            {advisor_details.map((item) => (
              <Box key={item.label}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "#00000099",
                    mb: 0.2,
                  }}
                >
                  {item.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "#000000DE",
                  }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>

          <ConfigAndMapDetailsTable tableHeadings={tableHeadings} rows={rows} />

          {/* Validation */}
          <Alert
            icon={<InfoOutlinedIcon />}
            severity="info"
            sx={{
              mt: 2.5,
              border: "1px solid #0288D180",
              borderRadius: "5px",
              backgroundColor: "#f4faff",
              color: "#0288D10A",
              alignItems: "flex-start",
              p: 1,

              "& .MuiAlert-icon": {
                color: "#0066a6",
                fontSize: "20px",
                p: 0,
              },

              "& .MuiAlert-message": {
                width: "100%",
                p: 0,
              },
            }}
          >
            <AlertTitle
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                letterSpacing: "0.5px",
                color: "#01579B",
                mb: 0,
              }}
            >
              VALIDATION
            </AlertTitle>

            <Typography
              sx={{
                fontSize: "14px",
                color: "#01579B",
              }}
            >
              Connecting a brand runs a live collection test through Argo (via the Connect Manager) before the connection is activated.
            </Typography>
          </Alert>

          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              Close
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default ConfigAndMapDetailsModal;
